module.exports = __webpack_public_path__ + "img/badge_inspection_master.c7ef8385.png";